import { Button, FloatingLabel, Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { billingApi } from '@reducers/billing';

const schema = Yup.object({
  balanceThreshold: Yup.string().required(),
});

export const BalanceThresholdForm = ({
  currentThreshold,
  currentThresholdValue,
}) => {
  const { login } = useSelector((state) => state.auth.user);
  const [updateQuery] = billingApi.useUpdateBalanceThresholdMutation();
  const onSubmit = async (values, actions) => {
    actions.setSubmitting(true);
    updateQuery({ data: values, login })
      .unwrap()
      .catch(() => {
        actions.setFieldError(
          'balanceThreshold',
          'Server-side error occurred.'
        );
        actions.setSubmitting(false);
      });
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={schema}
      initialValues={{
        balanceThreshold: currentThresholdValue || '',
      }}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <Form
          onSubmit={handleSubmit}
          className="col-md-10 offset-1 text-center"
        >
          <p>
            When the balance drops below this limit, you will get an email
            notification reminding you to top up your account.
          </p>
          <p>
            <strong>Current threshold:</strong> {currentThreshold}
          </p>
          <FloatingLabel
            controlId="floatingBalanceThreshold"
            label="Desired balance limit"
            className="mb-1"
          >
            <Form.Control
              type="input"
              size="sm"
              placeholder="Desired balance limit"
              name="balanceThreshold"
              value={values.balanceThreshold}
              onChange={handleChange}
              onBlur={handleBlur}
              isValid={touched.balanceThreshold && !errors.balanceThreshold}
              isInvalid={touched.balanceThreshold && errors.balanceThreshold}
            />
          </FloatingLabel>
          <hr />
          <Button type="submit" variant="didxl">
            Save
          </Button>
        </Form>
      )}
    </Formik>
  );
};
